import cx from 'classnames';
import { Check } from 'ethena-icons';
import _ from 'lodash';
import { InputHTMLAttributes, ReactNode, useRef } from 'react';
import css from './Checkbox.module.scss';

interface ICheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  customInputClassName?: string;
  label: ReactNode;
  size?: number;
  variant?: 'normal' | 'bordered';
}

export const Checkbox = ({
  className,
  customInputClassName,
  disabled,
  label,
  readOnly,
  size = 14,
  variant = 'normal',
  ...rest
}: ICheckboxProps) => {
  const { current: id } = useRef(_.uniqueId('checkbox'));
  return (
    <div
      className={cx(css.checkbox, css[size], css[variant], className, {
        [css.checked]: rest.checked,
        [css.disabled]: disabled,
        // When the Checkbox is being controlled by a parent component, we do
        // not want it to capture events, or else the parent click handler may
        // not fire.
        [css.eventless]: !rest.onChange,
        [css.readOnly]: readOnly,
      })}
    >
      <input
        disabled={disabled}
        readOnly={readOnly}
        type="checkbox"
        {...rest}
        id={id}
      />
      <label htmlFor={id} style={{ fontSize: size }}>
        <span
          className={cx(css.customInput, customInputClassName)}
          style={{
            height: size,
            minHeight: size,
            minWidth: size,
            width: size,
          }}
        >
          {rest.checked && (
            <Check className={css.check} height={size} width={size} />
          )}
        </span>
        {label}
      </label>
    </div>
  );
};
